import React, { useState } from 'react'
import Leaderboard from './leaderboard'
import TextInput from './textInput'
import ValidationSummary from './validationSummary'
const Joi = require('@hapi/joi')

const letMeKnowSchema = Joi.object({
  emailAddress: Joi.string().required().email().label('Email'),
})

const siteUrl = process.env.REACT_APP_SITE_URL

const FinalScores = ctx => {
  const { meet, isOwner } = ctx
  const [emailAddress, setEmailAddress] = useState('')
  const [optIn, setOptIn] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [validationErrors, setValidationErrors] = useState([])

  const handleChange = e => {
    setEmailAddress(e.target.value.trim())
  }

  const handleChangeOptIn = () => {
    setOptIn(!optIn)
  }

  const submitLetMeKnow = async () => {
    let validationResult = letMeKnowSchema.validate({emailAddress})
    if(validationResult.error) {
      setValidationErrors(validationResult.error.details)
      return
    }
    if(!submitted) {
      setSubmitted(true)
      await fetch(`/proxy/let-me-know`, {
        body: JSON.stringify({emailAddress, optIn}),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST'
      })
      setEmailSent(true)
    }
    setSubmitted(false)
  }

  return <div>
      <div>
        <Leaderboard leaderBoard={meet.leaderBoard} totalParticipants={meet.totalParticipants} />
      </div>
      <br />
      <br />
      <br />
    { isOwner ? <a className="button is-link is-medium" a href={`${siteUrl}/meets/new`}>Create a new Meeting</a> : null }
  { !isOwner ? <div className="notification is-info is-light">
      <h2 className="subtitle">
        Host your own Race Night
      </h2>
      { emailSent ? <p>We&apos;ve sent you an email. Hopefully see ya soon!!</p>
        : <div>
      <p>
        Pop in your email address and we&apos;ll send you some info on how to get started.
      </p>
      <ValidationSummary validationErrors={validationErrors} />
      <div className="field">
        <label htmlFor="name" className="label">Email address</label>
        <div className="control">
          <TextInput validationErrors={validationErrors} value={emailAddress} onChange={handleChange} name="emailAddress" />
        </div>
      </div>
      <div className="field consent">
        <label className="checkbox">
          <input value={optIn} type="checkbox" onChange={handleChangeOptIn} />
          I&apos;m happy to be contacted from time to time with offers and updates
        </label>
      </div>
      <button onClick={submitLetMeKnow} className="button is-link is-fullwidth  is-large" type="submit">
        Send me some info
      </button> 
      </div>}
      </div> : null }
    <style jsx>{`
       .consent input {
         margin-right: 10px;
       }
       .consent {
         margin: 2em 0;
         text-align: center;
         font-size: 0.8em;
       }
    `}</style>
    </div>
}

export default FinalScores
